import Image from "next/image"

import { Step } from "./Step"
import { useGetCompanyForCurrentSubdomain } from "./useGetCompanyForCurrentSubdomain"

export function SignInContent() {
  const { currentData: company } = useGetCompanyForCurrentSubdomain()
  const logoURL = company?.logoImageUrl ?? ""

  return (
    <div className="flex flex-col items-center gap-y-6">
      {logoURL && (
        <div className="bg-elevation-surface-default border-v2-border-default shadow-input w-45 h-30 rounded-lg border p-4">
          <div className="relative h-full w-full">
            <Image src={logoURL} alt="logo" fill className="object-contain" />
          </div>
        </div>
      )}
      <Step />
    </div>
  )
}
